<ng-template [ngIf]="legacyWebUI && url3_5">
  <p *ngIf="unsupportedPattern && !isProduction" style="font-weight: bold; color:red; height: 20px;text-align: center; position:absolute; width:100%">
    CURRENTLY UNSUPPORTED SOHO XI PATTERN DETECTED
  </p>
  <lm-html-url-doc
    [url]="url3_5"
    [showLoading]="false"
    (titleChanged)="onTitleChanged($event)"
  ></lm-html-url-doc>
</ng-template>
<ng-template [ngIf]="!url3_5">
  <ng-container *ngIf="pageSpec && pageSpec.pageSpec.hasCartForm">
    <div class="leftSideCartView">
      <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
      <ng-container *ngTemplateOutlet="CompositeFormMarkup"></ng-container>
    </div>
    <!-- This is where we will handle the mobile code -->
    <div class="rightSideCartView">
      <ng-container *ngTemplateOutlet="CartFormTemplate"></ng-container>
    </div>

  </ng-container>

  <ng-container *ngIf="pageSpec && !pageSpec.pageSpec.hasCartForm">
    <ng-container *ngIf="hasFullPageBackground; else NoFullBackground">
      <section
        class="use-background-image background-image-attributes full-page-background"
        [style.background-image]="fullPageBackgroundImage"
      >
        <ng-container *ngIf="bannerInRoute && isRouterOutletRootComponent; else ToolbarMarkup">   <!--   *ngIf="isRouterOutletRootComponent && (hideTitleBar || bannerInRoute)   -->
          <soho-header #SohoHeader [hasTabs]="hasTabs" [hasToolbar]="hasToolbar">
            <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
          </soho-header>
        </ng-container>
        <ng-container *ngTemplateOutlet="CompositeFormMarkup"></ng-container>
      </section>
    </ng-container>
    <ng-template #NoFullBackground>
      <ng-container *ngIf="bannerInRoute && isRouterOutletRootComponent; else ToolbarMarkup">   <!--   *ngIf="isRouterOutletRootComponent && (hideTitleBar || bannerInRoute)   -->
        <soho-header #SohoHeader [hasTabs]="hasTabs" [hasToolbar]="hasToolbar">
          <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
        </soho-header>
      </ng-container>
      <ng-container *ngTemplateOutlet="CompositeFormMarkup"></ng-container>
    </ng-template>
  </ng-container>
</ng-template>
  <!-- <ng-container *ngIf="hideTitleBar">
    <lm-toolbar
        class="hideTitleToolbar"
        [inHeader]="false"
        [toolbarIdPrefix]="screenId"
        [automationId]="pageAutomationId"
        [sectionTitle]="pageTitle"
        [buttons]="toolbarButtons | async"

        (toolbarButtonEvent)="onToolbarButtonButtonEvent($event)"
    ></lm-toolbar>
  </ng-container> -->
<ng-template #CartFormTemplate>
  <lm-form #cartForm
      class ="personalize-header"
      [formUrlInfo]="cartFormUrlInfo"
      [isCartView]=true
      [formSpec]="pageSpec.pageSpec.cartForm"
      [initDataView]="contextFormDataView"
      [pageContextForm]="true"
      [formOptions]="'{}'"
  ></lm-form>    <!-- style="border-left: 1px solid grey; width: 25%"  -->
</ng-template>

<ng-template #CompositeFormMarkup>
  <div [ngClass]="{'hideTitleBarPageScroll': hideTitleBar}">
    <ng-container *ngIf="hasContextForm">
      <section
        class="page-context-form"
        [class.is-personalizable]="!useThemeColor ? false : true"
        [class.use-background-image]="useBackgroundImage"
        [class.background-image-attributes]="useBackgroundImage"
        [class.foreground-light]="foregroundLight"
        [class.foreground-dark]="foregroundDark"
        [style.background-image]="backgroundImageUrl"
      >
        <lm-form
          [class.personalize-header]="!useThemeColor ? false : true"
          [formUrlInfo]="contextFormUrlInfo"
          [formSpec]="contextFormSpec"
          [initDataView]="contextFormDataView"
          [pageContextForm]="true"
          [formOptions]="'{}'"
        ></lm-form>
      </section>
    </ng-container>
    <ng-container *ngIf="isMultiPanel && lmTabsOptions && (hideTitleBar || hasContextForm)">
      <div soho-tabs #sohoTabContainer
        disableAutoUpdatedCall="true"
        class="sticky-tabs horizontal"
        [ngClass]="{ 'lm-banner-in-route header-tabs tab-continer' : bannerInRoute }"
        [class.is-personalizable]="!useThemeColor ? false : isPersonalizable"
        [alternate]="useAlternateTabs"
        [attributes]="pagePanelTabAttributes"
        [headerTabs]="!useThemeColor ? false : isPersonalizable"
        [verticalResponsive]="false"
        [class.hide-title-bar]="hideTitleBar"
        (activated)="onTabActivated($event)"
      >
        <div soho-tab-list-container>
          <ul soho-tab-list>
            <li soho-tab
                *ngFor="let tab of lmTabsOptions?.tabs"
                attr.id="{{testVersion1 ? 'pagepanel_' + tab.id : null}}"
                [selected]="tab.selected"
            >
              <a soho-tab-title
                  attr.id="{{!testVersion1 ? tab.id + '_tab' : null}}"
                  attr.data-automation-id="lm-{{tab.automationId + '-tab'}}"
                  tabId="{{tab.id}}"
              >{{tab.title}}</a>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
      <div *ngIf="isMultiPanel && lmTabsOptions" soho-tab-panel-container attr.id="{{tabPanelContainerId}}" [ngStyle]="{'height': onMobile ? '100%' : hideTitleBar ? 'auto' : null}">
        <ng-container *ngTemplateOutlet="MultiPanelMarkup"></ng-container>
      </div>

    <!--
    COMMON PANEL WORK
    -->
    <lm-page-panel
      *ngIf="isSinglePanel && lmTabsOptions && lmTabsOptions.tabs?.length > 0"
      tabindex="0"
      id="{{lmTabsOptions.tabs[0].id}}"
      #LMPagePanelComponent
      [class.lm-page-single-panel]="true"
      [panel]="lmTabsOptions.tabs[0].panel"
      [isSinglePanePage]="true"
      [overrideListTitle]="overrideListTitle"
      [messageRuleView]="dataView"
      [pageHasContextForm]="hasContextForm"
      (panelContentDisplayed)="onPanelContentDisplayed($event)"
      (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
      (sendContextMessageEvent)="onSendContextMessageEvent($event)"
      (panelContentModified)="onPanelContentModified($event)"
      (panelDataUpdated)="onPanelDataUpdated($event)"
    ></lm-page-panel>

    <div *ngIf="!hasPanels" class="noPageDetails">
      <p>{{noPageDetailsString}}</p>
    </div>
  </div>
</ng-template>

<ng-template #ToolbarMarkup>
  <ng-container *ngIf="hideTitleBar && bannerInRoute">
    <lm-toolbar
        [class.hideTitleToolbar]="!isRouterOutletRootComponent"
        [class.header]="pageSpec && pageSpec.pageSpec.hasCartForm"
        [inHeader]="isRouterOutletRootComponent && bannerInRoute"
        [toolbarIdPrefix]="screenId"
        [sectionTitle]="pageTitle"
        [buttons]="toolbarButtons | async"

        (toolbarButtonEvent)="onToolbarButtonButtonEvent($event)"
    ></lm-toolbar>
  </ng-container>
</ng-template>

<ng-template #MultiPanelMarkup>
  <div soho-tab-panel
    *ngFor="let tab of lmTabsOptions?.tabs trackBy: trackById"
      tabId="{{tab.id}}"
      [ngStyle]="{'height': onMobile ? '100%' : null}"
      attr.data-automation-id="lm-{{tab.automationId}}-panel"

  >
    <lm-page-panel #LMPagePanelComponent
        [panel]="tab?.panel"
        [insideTabs]="hideTitleBar"
        [messageRuleView]="dataView"
        [pageHasContextForm] = "hasContextForm"
        [pageHasTabs]="true"
        (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
        (panelContentModified)="onPanelContentModified($event)"
        (panelDataUpdated)="onPanelDataUpdated($event)"
    ></lm-page-panel>
  </div>
</ng-template>

<div #dialogPlaceholder id="lmPageDialogPlaceholder" class="lmDialogPlaceholder"></div>
